<template>
  <div class="row" style="
      background: url('/img/bg-1.png') no-repeat left;
      background-size: contain;
      height: 100vh;
      overflow-x: hidden;
    ">
    <div class="col-lg"></div>
    <div class="col-lg-10">
      <div v-if="isLoading" class="loading-overlay">
        <loading loader="dots" :height="170" :width="170" color="#3282b8" background-color="#505273" transition="fade"
          :active="isLoading" :is-full-page="true"></loading>
      </div>

      <modal :show.sync="modals.infoModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15b0cf;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-info"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Info!
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 30px">
            <base-button type="primary" v-on:click="modals.infoModal = false">Ok</base-button>
          </div>
        </div>
      </modal>
      <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />

      <modal :show.sync="modals.cancelModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #cf6a15;
          ">
          <div class="row">
            <div class="col-lg"></div>

            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-question"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Are you sure?
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">All changes will not be updated.</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-6 text-right" style="margin-bottom: 30px">
            <base-button type="danger" v-on:click="modals.cancelModal = false">Cancel</base-button>
          </div>
          <div class="col-lg-6 text-left" style="margin-bottom: 30px">
            <base-button type="primary" v-on:click="redirect()">Continue</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.failedModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #EC1B23;
            text-align: center;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-exclamation"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Error
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <p style="color: #A5A5A5; margin-top: 20px">
              Click 'Retry' to go back.
            </p>

            <base-button type="danger" v-on:click="getBack()">Exit</base-button>&nbsp;
            <base-button type="primary" v-on:click="closeFailedModal()">Retry</base-button>
          </div>
        </div>
      </modal>
      <br />
      <br />
      <br />
      <div v-if="firstpage">
        <!-- <div class="full-page" :class="pageClass"> -->
        <div class="content">
          <div class="row">
            <div style="" class="col-lg-12 text-center">
              <p style="font-size: 29px; color: #358CCB">Sign Up</p>
            </div>
          </div>
          <div class="row">
            <div style="" class="col-lg-12 text-center">
              <p style="font-size: 18px; color: #b9b9b9">
                Please fill up the information to register
              </p>
            </div>
          </div>

          <div class="row scrollable-row">
            <div class="col-lg-4 d-flex">
              <card class="card-eprf">
                <br />
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                      BASIC DETAILS
                    </p>
                  </div>
                </div>
                <p style="color: #A5A5A5; opacity: 0.7">
                  Company Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyname" :class="{ 'custom-input': true }" />
                </div>
                <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                  {{ company_unique }}
                </p>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Operation Type <span style="color: #EC1B23">*</span>
                </p>
                <el-select class="select-info tab select-width" placeholder="Select" v-model="selects.operationtype"
                  style="width: 90%; border-bottom: 1px solid lightgray" @change="getType()" filterable>
                  <el-option v-for="option in selects.operationtypes" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Company Address <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyaddress" :class="{ 'custom-input': true }" />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phoneno" :class="{ 'custom-input': true }" />
                  <p v-if="isphoneno" style="font-size: 11px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">Fax No.</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="faxno" :class="{ 'custom-input': true }" />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Supporting Document (i.e SSM, Form 29, etc)
                </p>
                <div class="fileinput">
                  <label style="color: white" for="sup-upload" type="primary" class="btn">
                    Upload
                  </label>
                  <div class="d-flex justify-content-center spinner" v-if="supportload == true">
                    <circle-8></circle-8>
                  </div>

                  <input accept="application/pdf" id="sup-upload" ref="supupload" type="file" name="..." class="valid"
                    :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChange" />
                </div>
                <div style="
                    height: 50px;
                    padding: 0px 20px 20px 0px;
                    margin: 0px 30px 20px 0px;
                  " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                  <!-- <div
                    v-for="(file, index) in allfilename"
                    :key="index"
                    class="row"
                  >
                    <div class="col-lg-8">
                      <p
                        style="padding-left: 15px; color: #A5A5A5; opacity: 0.7"
                        v-if="selectedFileName"
                        id="file-name"
                      >
                        {{ file }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <p
                        v-if="selectedFileName"
                        style="font-size: 12px; color: #aaa; opacity: 0.5"
                        @click="removeFile(index)"
                      >
                        Remove
                      </p>
                    </div>
                  </div> -->
                  <div v-for="(file, index) in support_doc_list" :key="index" class="row">
                    <div class="col-lg-8">
                      <a :href="file.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ file.filename }}
                        </base-button>
                      </a>
                    </div>
                    <div class="col-lg-4">
                      <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeFile2(index)">
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg-4 d-flex" v-for="(item, index) in pics" :key="index">
              <card class="card-eprf">
                <br />
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                      PIC DETAILS - {{ index + 1 }}
                    </p>
                  </div>
                  <div class="col-lg-2 text-right">
                    <base-button class="btn-cancel btn-icon btn-round" @click="removepic(index)">
                      <i class="tim-icons icon-simple-remove"> </i></base-button>
                  </div>
                </div>
                <p style="color: #A5A5A5; opacity: 0.7">
                  User name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.fullname" :class="{ 'custom-input': true }" />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Password <span style="color: #EC1B23">*</span>
                </p>
                <div class="col-lg-12">
                  <div class="row">
                    <input class="col-lg" v-if="item.showPassword1" type="text" v-model="item.password"
                      :class="{ 'custom-input': true }" />
                    <input class="col-lg" v-else type="password" v-model="item.password" @focus="short = true"
                      :class="{ 'custom-input': true }" />
                    <button class="custom-button" @click="toggleShow1(index)">
                      <span class="icon is-small is-right">
                        <i class="fas" :class="{
        'fa-eye-slash': item.showPassword1,
        'fa-eye': !item.showPassword1,
      }"></i>
                      </span>
                    </button>
                    <el-tooltip class="col-lg-1" effect="light" :open-delay="300" placement="top">
                      <template v-slot:content>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!item.alphanumeric" class="fas fa-times-circle red-circle"></i>
                            <i v-if="item.alphanumeric" class="fas fa-check-circle green-circle"></i>
                            At least 8 alphanumeric characters
                          </p>
                          &nbsp;&nbsp;
                        </div>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!item.upperlower" class="fas fa-times-circle red-circle"></i>
                            <i v-if="item.upperlower" class="fas fa-check-circle green-circle"></i>
                            Must include uppercase and lowercase
                          </p>
                        </div>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!item.special" class="fas fa-times-circle red-circle"></i>
                            <i v-if="item.special" class="fas fa-check-circle green-circle"></i>
                            Must include symbol (e.g. !@#$%^&*)
                          </p>
                        </div>
                      </template>
                      <base-button type="link">
                        <i class="tim-icons icon-alert-circle-exc"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Confirm Password <span style="color: #EC1B23">*</span>
                </p>

                <div style="padding-right: 30px; display: flex">
                  <input v-if="item.showPassword" type="text" v-model="item.confirmpassword"
                    @focus="item.showPasswordMismatch = true" :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="item.confirmpassword" @focus="item.showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow(index)">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
        'fa-eye-slash': item.showPassword,
        'fa-eye': !item.showPassword,
      }"></i>
                    </span>
                  </button>
                </div>

                <div style="display: flex; height: 30px">
                  <p v-if="item.showPasswordMismatch &&
        item.confirmpassword !== item.password
        " style="font-size: 11px; color: #ea2127">
                    {{ item.pwdmessage }}
                  </p>
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.phoneno1" :class="{ 'custom-input': true }" />
                  <p v-if="item.phoneno1.length <= 7" style="font-size: 11px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">Fax No.</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.faxno1" :class="{ 'custom-input': true }" />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Email <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.email" :class="{ 'custom-input': true }" />
                </div>
                <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                  {{ item.email_unique }}
                </p>
              </card>
            </div>
            <div class="col-lg-4 d-flex">
              <card class="card-eprf">
                <br />
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                      ADD PIC
                    </p>
                  </div>
                </div>
                <div class="w-100 p-4 d-flex align-items-center justify-content-center" style="height: 400px">
                  <div style="
                      padding: 60px;
                      background-color: white;
                      border-radius: 100px;
                      border: 10px solid #358CCB;
                    ">
                    <i style="
                        cursor: pointer;
                        color: #358CCB;
                        font-size: 60px;
                        font-weight: 900;
                      " class="tim-icons icon-simple-add" @click="addCard()"></i>
                  </div>
                </div>
              </card>
            </div>
            <!-- <div v-else-if="this.addPIC == 'true'" class="col-lg-3 d-flex">
              <card
                style="box-shadow: none; height: 630px; background-color: white"
              >
                <div style="display: flex">
                  <div class="col-lg-9">
                    <p
                      style="
                        color: #358CCB;
                        font-size: 24px;
                        font-weight: 300;
                        padding: 30px 30px 0px 15px;
                        margin-bottom: -1px;
                      "
                    >
                      PIC DETAILS - 2
                    </p>
                  </div>
                  <div class="col-lg"></div>
                  <div>
                    <div
                      style="
                        position: relative;
                        height: 30px;
                        width: 30px;
                        background-color: #ea2127;
                        border-radius: 100px;
                      "
                    >
                      <i
                        style="
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                          color: white;
                          font-weight: 900;
                          font-size: 15px;
                        "
                        class="tim-icons icon-simple-remove"
                        @click="cancelAddCard()"
                      ></i>
                    </div>
                  </div>
                </div>
                <p style="padding-left: 30px; color: #A5A5A5; opacity: 0.7">
                  Full Name
                </p>
                <div style="padding-left: 30px; padding-right: 30px">
                  <input
                    type="text"
                    v-model="fullname2"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p
                  style="
                    padding-left: 30px;

                    color: #A5A5A5;
                    opacity: 0.7;
                  "
                >
                  Password
                </p>
                <div
                  style="padding-left: 30px; padding-right: 30px; display: flex"
                >
                  <input
                    v-if="showPassword2"
                    type="text"
                    v-model="password2"
                    :class="{ 'custom-input': true }"
                  />
                  <input
                    v-else
                    type="password"
                    v-model="password2"
                    @focus="short1 = true"
                    :class="{ 'custom-input': true }"
                  />
                  <button class="custom-button" @click="toggleShow2">
                    <span class="icon is-small is-right">
                      <i
                        class="fas"
                        :class="{
                          'fa-eye-slash': showPassword2,
                          'fa-eye': !showPassword2,
                        }"
                      ></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex">
                  <p
                    style="
                      padding-left: 30px;
                      font-style: italic;
                      font-size: 12px;
                      color: #5a5a5a;
                      opacity: 0.5;
                    "
                  >
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp;
                  <p
                    v-if="password2.length < 8 && short1"
                    style="font-size: 12px; color: #ea2127"
                  >
                    Not enough characters
                  </p>
                </div>

                <p style="padding-left: 30px; color: #A5A5A5; opacity: 0.7">
                  Confirm Password
                </p>
                <div
                  style="padding-left: 30px; padding-right: 30px; display: flex"
                >
                  <input
                    v-if="showPassword3"
                    type="text"
                    v-model="confirmpassword2"
                    @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }"
                  />
                  <input
                    v-else
                    type="password"
                    v-model="confirmpassword2"
                    @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }"
                  />
                  <button class="custom-button" @click="toggleShow3">
                    <span class="icon is-small is-right">
                      <i
                        class="fas"
                        :class="{
                          'fa-eye-slash': showPassword3,
                          'fa-eye': !showPassword3,
                        }"
                      ></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex">
                  <p
                    style="
                      padding-left: 30px;
                      font-style: italic;
                      font-size: 12px;
                      color: #5a5a5a;
                      opacity: 0.5;
                    "
                  >
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp;
                  <p
                    v-if="
                      showPasswordMismatch && confirmpassword2 !== password2
                    "
                    style="font-size: 12px; color: #ea2127"
                  >
                    {{ message }}
                  </p>
                </div>

                <p style="padding-left: 30px; color: #A5A5A5; opacity: 0.7">
                  Phone No.
                </p>
                <div style="padding-left: 30px; padding-right: 30px">
                  <input
                    type="text"
                    v-model="phoneno2"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p style="padding-left: 30px; color: #A5A5A5; opacity: 0.7">
                  Fax No.
                </p>
                <div style="padding-left: 30px; padding-right: 30px">
                  <input
                    type="text"
                    v-model="faxno2"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p style="padding-left: 30px; color: #A5A5A5; opacity: 0.7">
                  Email
                </p>
                <div style="padding-left: 30px; padding-right: 30px">
                  <input
                    type="text"
                    v-model="email2"
                    :class="{ 'custom-input': true }"
                  />
                </div>
                <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                  {{ this.email2_unique }}
                </p>
              </card>
            </div> -->
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6"></div>
            <div class="col-lg-3 text-right">
              <base-button type="danger" v-on:click="getLogin()">Cancel</base-button>&nbsp;
              <base-button type="primary" :disabled="buttondisabled" v-on:click="getDone()">Next</base-button>
            </div>

          </div>
        </div>
      </div>
      <div v-if="!firstpage">
        <!-- <div class="full-page" :class="pageClass"> -->
        <div class="content">
          <div class="row">
            <div style="" class="col-lg-12 text-center">
              <p style="font-size: 29px; color: #358CCB">Sign Up</p>
            </div>
          </div>
          <div class="row">
            <div style="" class="col-lg-12 text-center">
              <p style="font-size: 18px; color: #b9b9b9">
                Please fill up the information to register
              </p>
            </div>
          </div>

          <div class="row scrollable-row">
            <div class="col-lg"></div>

            <div class="col-lg-9 d-flex" v-for="(item, index) in ships" :key="index">
              <card class="card-eprf">
                <br />
                <div class="row">
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg">
                        <p style="
                            color: #358CCB;
                            font-size: 24px;
                            font-weight: 300;
                          ">
                          SHIP DETAILS
                        </p>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-lg-6">
                          <p style="color: #A5A5A5; opacity: 0.7">Ship Name</p>
                          <div style="padding-right: 30px">
                            <input type="text" v-model="item.shipname" :class="{ 'custom-input': true }" />
                          </div>

                          <p style="color: #A5A5A5; opacity: 0.7">IMO No.</p>
                          <div style="padding-right: 30px">
                            <input type="text" v-model="item.imono" :class="{ 'custom-input': true }" />
                          </div>
                          <p style="
                              color: #A5A5A5;
                              font-size: 10px;
                              margin-top: -1px;
                            ">
                            {{ item.imono_unique }}
                          </p>

                          <p style="color: #A5A5A5; opacity: 0.7">Ship Type</p>
                          <!-- @change="getType()" -->
                          <el-select class="select-info tab select-width" popper-class="custom-dropdown"
                            placeholder="Select" v-model="item.ship" style="
                              width: 90%;
                              border-bottom: 1px solid lightgray;
                            " filterable>
                            <el-option v-for="option in selects.ships" class="select-info custom-option"
                              :value="option.value" :label="option.label" :key="option.value"></el-option>
                          </el-select>
                          <div v-if="item.ship == '8'" style="padding-right: 30px; padding-top: 20px">
                            <input type="text" v-model="specify" :class="{ 'custom-input': true }" />
                          </div>

                          <p style="color: #A5A5A5; opacity: 0.7">
                            Gross Tonnage
                          </p>
                          <div style="padding-right: 30px">
                            <input type="text" v-model="item.grosstonnage" :class="{ 'custom-input': true }" />
                          </div>

                          <p style="color: #A5A5A5; opacity: 0.7">
                            Deadweight Tonnage (kg)
                          </p>
                          <div style="padding-right: 30px">
                            <input type="text" v-model="item.deadweight" :class="{ 'custom-input': true }" />
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <p style="color: #A5A5A5; opacity: 0.7">
                            Owner / Operator Name
                          </p>
                          <div style="padding-right: 30px">
                            <input type="text" v-model="item.ownername" :class="{ 'custom-input': true }" />
                          </div>

                          <p style="color: #A5A5A5; opacity: 0.7">Call Sign</p>
                          <div style="padding-right: 30px">
                            <input type="text" v-model="item.callsign" :class="{ 'custom-input': true }" />
                          </div>

                          <p style="color: #A5A5A5; opacity: 0.7">Flag State</p>
                          <!-- @change="getType()" -->
                          <el-select class="select-info tab select-width" placeholder="Select" v-model="item.state"
                            style="
                              width: 90%;
                              border-bottom: 1px solid lightgray;
                            " filterable>
                            <el-option v-for="option in selects.states" class="select-info" :value="option.value"
                              :label="option.label" :key="option.value"></el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg">
                        <p style="
                            color: #358CCB;
                            font-size: 24px;
                            font-weight: 300;
                          ">
                          SUSTAINABLE CERTIFICATES
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="w-100 p-4 d-flex align-items-center justify-content-center" style="height: 250px">
                      <div class="w-100 p-4 d-flex align-items-center justify-content-center" style="
                          border: 2px dashed #dcdcdc;
                          height: 280px;
                          width: 350px;
                        ">
                        <div class="col-lg-12 text-center">
                          <i style="
                              color: lightgray;
                              font-size: 90px;
                              font-weight: 500;
                              margin-bottom: 10px;
                            " class="tim-icons icon-upload"></i>

                          <p style="font-weight: 600; color: #787878">
                            Drop files to upload
                          </p>
                          <div class="row">
                            <div class="col-lg"></div>

                            <p style="font-weight: 600; color: #787878">or</p>
                            &nbsp;
                            <div class="fileinput">
                              <label :for="index + 'file-upload'">
                                <p style="
                                    font-weight: 600;
                                    font-size: 14px;
                                    color: #5e99ff;
                                    text-decoration: underline;
                                    cursor: pointer;
                                  ">
                                  browse
                                </p>
                              </label>
                              <input accept="application/pdf" :id="index + 'file-upload'" ref="file" type="file"
                                name="..." class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                v-on:change="onFileChangee($event, index)" />
                            </div>

                            <div class="col-lg"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style="
                        height: 200px;
                        padding: 20px;
                        margin: 30px 30px 20px 0px;
                      " class="d-flex justify-content-center spinner" v-if="item.uploadload">
                      <circle-8></circle-8>
                    </div>

                    <div style="
                        height: 200px;
                        padding: 20px;
                        margin: 30px 30px 20px 0px;
                      " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                      <!-- <p style="color: pink;">{{ item.doc }}</p> -->
                      <div v-for="(file, index) in item.doc" :key="index" class="row">
                        <div class="col-lg-8">
                          <a :href="file.fileurl">
                            <base-button class="btn-link btn-primary">
                              {{ file.filename }}
                            </base-button>
                          </a>
                        </div>
                        <div class="col-lg-4">
                          <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeFilee(index)">
                            Remove
                          </base-button>
                        </div>
                      </div>

                      <!-- <div
                        v-for="(file, index) in support_doc_list"
                        :key="index"
                        class="row"
                      >
                        <div class="col-lg-8">
                          <p
                            style="
                              padding-left: 15px;
                              color: #A5A5A5;
                              opacity: 0.7;
                            "
                            id="file-name"
                          >
                            {{ support_doc_list[index] }}
                          </p>
                        </div>
                        <div class="col-lg-4">
                          <p
                            style="font-size: 12px; color: #aaa; opacity: 0.5"
                            @click="removeFilee2(index)"
                          >
                            Remove
                          </p>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-lg-1 text-right">
                    <base-button class="btn-icon btn-round btn-cancel" @click="removeship(index)"><i
                        class="tim-icons icon-simple-remove"></i></base-button>
                  </div>
                </div>
              </card>
            </div>

            <div class="col-lg-3 d-flex">
              <card class="card-eprf">
                <br />
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                      ADD SHIP
                    </p>
                  </div>
                </div>
                <div class="w-100 p-4 d-flex align-items-center justify-content-center" style="height: 400px">
                  <div style="
                      padding: 60px;
                      background-color: white;
                      border-radius: 100px;
                      border: 10px solid #358CCB;
                    ">
                    <i style="
                        cursor: pointer;
                        color: #358CCB;
                        font-size: 60px;
                        font-weight: 900;
                      " class="tim-icons icon-simple-add" @click="addShip()"></i>
                  </div>
                </div>
              </card>
            </div>
            <!-- <div class="col-lg-6 d-flex">
              <card class="card-eprf">
                <br />
                <div class="row">
                  <div class="col-lg">
                    <p
                      style="color: #358CCB; font-size: 24px; font-weight: 300"
                    >
                      ADD SHIP DETAILS
                    </p>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg"></div>
                  </div>
                </div>
              </card>
            </div> -->
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6"></div>
            <div class="col-lg-3 text-right">
              <base-button type="danger" v-on:click="getBack()">Back</base-button>&nbsp;
              <base-button type="primary" :disabled="buttondisabled" v-on:click="handleDone()">Done</base-button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="col-lg"></div>
  </div>
</template>
<script>
import { Select, Option, Tooltip } from "element-ui";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../../components/Cards/Card.vue";
import { Modal, ImageUpload } from "../../../../src/components";
import { debounce } from "src/util/debounce";
import Loading from "vue-loading-overlay";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  name: "VesselRegistration",
  components: {
    StatusModal,
    Card,
    Modal,
    [Tooltip.name]: Tooltip,
    [Select.name]: Select,
    [Option.name]: Option,
    ImageUpload,
    Circle8,
    Loading,
  },

  data() {
    return {
      alphanumeric: false,
      upperlower: false,
      special: false,
      alphanumeric2: false,
      upperlower2: false,
      special2: false,
      modal: modal,
      supportload: false,
      ships: [
        {
          uploadload: false,
          shipname: "",
          imono: "",
          shiptype: "",
          grosstonnage: "",
          deadweight: "",
          ownername: "",
          callsign: "",
          flagstate: "",
          imono_unique: "",
          ship: "",
          state: "",
          doc: [],
        },
      ],
      firstpage: true,
      company_unique: "",
      email_unique: "",
      email2_unique: "",

      selectedFileName: "",
      allfilename: [],

      selectedFileNamee: "",
      allfilenamee: [],
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,

      short: "",
      short1: "",
      showPasswordMismatch: "",

      positionID: 0,
      roleID: 0,

      operationtypevalue: 0,
      pics: [
        {
          alphanumeric: false,
          upperlower: false,
          special: false,
          uploadload: false,
          fullname: "",
          showPassword1: false,
          showPassword: false,
          showPasswordMismatch: false,
          password: "",
          confirmpassword: "",
          phoneno1: "",
          pwdmessage: "Password mismatch.",
          faxno1: "",
          email: "",
          email_unique: "",
        },
      ],
      pic: [],

      shipdocid: [],
      docid: [],

      //data from user
      companyname: "",
      operationtype: 0,
      companyaddress: "",
      phoneno: "",
      isphoneno: false,
      faxno: "",
      supportdoc: "",

      fullname: "",
      password: "",
      confirmpassword: "",
      phoneno1: "",
      faxno1: "",
      email: "",
      imono_unique: "",

      fullname2: "",
      password2: "",
      confirmpassword2: "",
      phoneno2: "",
      faxno2: "",
      email2: "",
      isLoading: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      selects: {
        operationtype: "owner",
        operationtypes: [
          { value: "owner", label: "Ship owner" },
          { value: "operator", label: "Operator" },
          { value: "liner", label: "Liner" },
          { value: "charterer", label: "Charterer" },
          { value: "agent", label: "Agent" },
        ],

        ship: "",
        ships: [],

        state: "",
        states: [],
      },

      addPIC: "false",

      modals: {
        successModal: false,
        failedModal: false,
        infoModal: false,
        cancelModal: false,
      },

      docs: "",
      docss: "",

      document: 0,
      documentt: 0,

      documentID: [],

      uploadload: false,

      upload: false,

      support_doc: "",
      support_doc_list: [],

      buttondisabled: false,
      message: "",
      pwdmessage: "",
    };
  },
  methods: {
    checkPassword(value, index) {
      const alphanumericPattern =
        /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*]/.test(value);

      if (alphanumericPattern.test(value)) {
        this.pics[index].alphanumeric = true;
      } else {
        this.pics[index].alphanumeric = false;
      }

      if (hasUppercase && hasLowercase) {
        this.pics[index].upperlower = true;
      } else {
        this.pics[index].upperlower = false;
      }

      if (hasSpecialChar) {
        this.pics[index].special = true;
      } else {
        this.pics[index].special = false;
      }

      if (
        this.pics[index].showPasswordMismatch &&
        this.pics[index].confirmpassword !== value
      ) {
        this.pics[index].pwdmessage = "Passwords mismatch.";
      } else {
        this.pics[index].pwdmessage = "";
      }

      console.log(this.message);
    },

    checkPassword2(value) {
      const alphanumericPattern =
        /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*]/.test(value);

      if (alphanumericPattern.test(value)) {
        this.alphanumeric2 = true;
      } else if (!alphanumericPattern.test(value)) {
        this.alphanumeric2 = false;
      }

      if (hasUppercase && hasLowercase) {
        this.upperlower2 = true;
      } else if (!hasUppercase || !hasLowercase) {
        this.upperlower2 = false;
      }

      if (hasSpecialChar) {
        this.special2 = true;
      } else if (!hasSpecialChar) {
        this.special2 = false;
      }

      console.log(this.message);
    },
    removeship(index) {
      this.ships.splice(index, 1);
    },
    async checkemail(email) {
      console.log(email);
      // this.email_unique = "";
      // let erer = ""
      let obj = {
        user_email: email,
      };

      return this.$http
        .post(":10001/api/v1/helper/check-user-email", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            // erer = response
            return response;
            // this.buttondisabled = false;
          }
        })
        .catch((err) => {
          // erer = err.response.data.message
          return err.response.data.message;
        });
      // console.log(erer)

      // return erer

      // this.email_unique = "";
    },
    addShip() {
      this.ships.push({
        uploadload: false,
        shipname: "",
        imono: "",
        shiptype: "",
        grosstonnage: "",
        deadweight: "",
        ownername: "",
        callsign: "",
        flagstate: "",
        imono_unique: "",
        ship: "",
        state: "",
        doc: [],
      });
    },
    removepic(index) {
      console.log(this.pics);
      this.pics.splice(index, 1);
    },
    getShipType() {
      (this.selects.ships = []),
        this.$http.get(":10001/api/v1/setting/ship_types").then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("data here", response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].ship_type_name,
                value: response[i].ship_type_id,
              };

              this.selects.ships.push(obj);
            }

            //default value
            if (typeof this.shiptypevalue === "number") {
              this.selects.ship = this.selects.ships[this.shiptypevalue].value;
            } else {
              this.selects.ship = this.selects.ships[0].value;
            }
          }
        });
    },
    getFlagState() {
      this.selects.states = [];
      this.$http.get(":10001/api/v1/setting/flags").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log("data here", response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].country_name,
              value: response[i].flag_id,
            };

            this.selects.states.push(obj);
          }

          //default value
          if (typeof this.flag === "number") {
            this.selects.state = this.selects.states[this.flag].value;
          } else {
            this.selects.state = this.selects.states[0].value;
          }
        }
      });
    },
    getBack() {
      this.firstpage = true;
    },
    getIndex() {
      return this.selects.operationtypes.findIndex(
        (option) => option.value === this.selects.operationtype
      );
    },
    toggleShow(index) {
      this.pics[index].showPassword = !this.pics[index].showPassword;
    },
    toggleShow1(index) {
      this.pics[index].showPassword1 = !this.pics[index].showPassword1;
      console.log("tekan ke tak?");
    },

    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    },
    toggleShow3() {
      this.showPassword3 = !this.showPassword3;
    },

    addCard() {
      // this.addPIC = "true";
      this.pics.push({
        fullname: "",
        showPassword1: false,
        showPassword: false,
        showPasswordMismatch: false,
        password: "",
        confirmpassword: "",
        phoneno1: "",
        message: "",
        faxno1: "",
        email: "",
        email_unique: "",
      });
    },
    cancelAddCard() {
      sessionStorage.removeItem("vessel-full-name2");
      sessionStorage.removeItem("vessel-email2");
      sessionStorage.removeItem("vessel-phone-no2");
      sessionStorage.removeItem("vessel-fax-no2");
      sessionStorage.removeItem("vessel-password2");
      sessionStorage.removeItem("vessel-confirm-password2");

      this.fullname2 =
        sessionStorage.getItem("vessel-full-name2") !== null &&
          sessionStorage.getItem("vessel-full-name2") !== "null"
          ? sessionStorage.getItem("vessel-full-name2")
          : "";

      this.password2 =
        sessionStorage.getItem("vessel-password2") !== null &&
          sessionStorage.getItem("vessel-password2") !== "null"
          ? sessionStorage.getItem("vessel-password2")
          : "";

      this.confirmpassword2 =
        sessionStorage.getItem("vessel-confirm-password2") !== null &&
          sessionStorage.getItem("vessel-confirm-password2") !== "null"
          ? sessionStorage.getItem("vessel-confirm-password2")
          : "";

      this.phoneno2 =
        sessionStorage.getItem("vessel-phone-no2") !== null &&
          sessionStorage.getItem("vessel-phone-no2") !== "null"
          ? sessionStorage.getItem("vessel-phone-no2")
          : "";
      this.faxno2 =
        sessionStorage.getItem("vessel-fax-no2") !== null &&
          sessionStorage.getItem("vessel-fax-no2") !== "null"
          ? sessionStorage.getItem("vessel-fax-no2")
          : "";
      this.email2 =
        sessionStorage.getItem("vessel-email2") !== null &&
          sessionStorage.getItem("vessel-email2") !== "null"
          ? sessionStorage.getItem("vessel-email2")
          : "";
      this.addPIC = "false";
    },
    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },
    getType() { },
    getLogin() {
      // sessionStorage.removeItem("position-id");
      // sessionStorage.removeItem("role-id");
      // sessionStorage.removeItem("vessel-add-pic");
      // sessionStorage.removeItem("vessel-support-doc");
      // sessionStorage.removeItem("vessel-support-doc-1");

      // sessionStorage.removeItem("vessel-company-name");
      // sessionStorage.removeItem("vessel-operation-type");
      // sessionStorage.removeItem("vessel-operation-type-value");
      // sessionStorage.removeItem("vessel-company-address");
      // sessionStorage.removeItem("vessel-phone-no");
      // sessionStorage.removeItem("vessel-fax-no");

      // sessionStorage.removeItem("vessel-full-name");
      // sessionStorage.removeItem("vessel-email");
      // sessionStorage.removeItem("vessel-phone-no1");
      // sessionStorage.removeItem("vessel-fax-no1");
      // sessionStorage.removeItem("vessel-password");
      // sessionStorage.removeItem("vessel-confirm-password");

      // sessionStorage.removeItem("vessel-full-name2");
      // sessionStorage.removeItem("vessel-email2");
      // sessionStorage.removeItem("vessel-phone-no2");
      // sessionStorage.removeItem("vessel-fax-no2");
      // sessionStorage.removeItem("vessel-password2");
      // sessionStorage.removeItem("vessel-confirm-password2");

      // sessionStorage.removeItem("vessel-ship-name");
      // sessionStorage.removeItem("vessel-imo-no");
      // sessionStorage.removeItem("vessel-ship-type-value");
      // sessionStorage.removeItem("vessel-ship-type-specify");
      // sessionStorage.removeItem("vessel-flag");

      // sessionStorage.removeItem("vessel-gross-tonnage");
      // sessionStorage.removeItem("vessel-dead-weight");
      // sessionStorage.removeItem("vessel-owner-name");
      // sessionStorage.removeItem("vessel-call-sign");
      // sessionStorage.removeItem("vessel-ship-doc");
      this.$router.push("/login");
    },
    handleDone() {
      let flag = "notcheck";

      for (var i = 0; i < this.pics.length; i++) {
        if (
          this.companyname != "" &&
          this.selects.operationtype != "" &&
          this.companyaddress != "" &&
          this.phoneno != "" &&
          this.pics[i].fullname != "" &&
          this.pics[i].password != "" &&
          this.pics[i].confirmpassword != "" &&
          this.pics[i].phoneno1 != "" &&
          this.pics[i].email != ""
        ) {
          let picss = {
            user_name: this.pics[i].fullname,
            user_email: this.pics[i].email,
            user_phone_number: this.pics[i].phoneno1,
            user_fax_number: this.pics[i].faxno1,
            password: this.pics[i].password,
            confirm_password: this.pics[i].confirmpassword,
          };

          this.pic.push(picss);
          flag = "checked";
        } else {
          flag = "notcheck";
          this.message = "Please fill all the required column";
          this.modals.infoModal = true;
        }
      }

      let shipped = [];
      for (var i = 0; i < this.ships.length; i++) {
        let doccc = [];

        for (var j = 0; j < this.ships[i].doc.length; j++) {
          doccc.push(this.ships[i].doc[j].fileid);
        }

        if (
          this.ships[i].shipname != "" &&
          this.ships[i].imono != "" &&
          this.ships[i].shiptype != "" &&
          this.ships[i].grosstonnage != "" &&
          this.ships[i].deadweight != "" &&
          this.ships[i].ownername != "" &&
          this.ships[i].callsign != "" &&
          this.ships[i].flagstate != ""
        ) {
          flag = "checked";
          let shippp = {
            ship_name: this.ships[i].shipname,
            imo_number: this.ships[i].imono,
            ship_type_id: parseInt(this.ships[i].shiptype),
            gross_tonnage: parseInt(this.ships[i].grosstonnage),
            deadweight_tonnage: parseInt(this.ships[i].deadweight),
            operator_name: this.ships[i].ownername,
            call_sign: this.ships[i].callsign,
            flag_id: parseInt(this.ships[i].flagstate),
            ship_documents: doccc,
          };
          shipped.push(shippp);
        } else {
        }
      }

      // let pic1 = {
      //   user_name: this.fullname,
      //   user_email: this.email,
      //   user_phone_number: this.phoneno1,
      //   user_fax_number: this.faxno1,
      //   password: this.password,
      //   confirm_password: this.confirmpassword,
      // };
      // this.pic.push(pic1);

      // if (this.addPIC == "true") {
      //   let pic2 = {
      //     user_name: this.fullname2,
      //     user_email: this.email2,
      //     user_phone_number: this.phoneno2,
      //     user_fax_number: this.faxno2,
      //     password: this.password2,
      //     confirm_password: this.confirmpassword2,
      //   };
      //   this.pic.push(pic2);
      // }

      let obj = {
        position_id: parseInt(this.positionID),
        role_id: parseInt(this.roleID),
        company_name: this.companyname,
        operation_type_id: parseInt(this.selects.operationtype),
        company_address: this.companyaddress,
        company_phone_number: this.phoneno,
        company_fax_number: this.faxno,
        documents: this.docid, // document sini

        pic: this.pic,

        ship: shipped,
      };

      console.log("datas", obj);
      if (flag == "checked") {
        this.isLoading = true;

        this.$http
          .post(":10001/api/v1/register/customer_vessel", obj)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              this.message = response;
              this.modals.successModal = true;
              this.isLoading = false;

              setTimeout(() => {
                this.$router.push("/login")
              }, 2000)
            } else {
              this.modals.failedModal = true;
            }
          })
          .catch((err) => {
            this.message = err.response.data.message;
            this.modals.failedModal = true;
            this.isLoading = false;
          });
      }
    },
    onFileChange(event) {
      this.supportload = true;
      const t = event.target;
      // if (t.files.length > 0) {
      //   for (let i = 0; i < t.files.length; i++) {
      //     this.selectedFileName = t.files[i].name;
      //     this.allfilename.push(this.selectedFileName);
      //   }
      //   // sessionStorage.setItem("vessel-support-doc", this.allfilename);
      // } else {
      //   this.selectedFileName = "";
      // }

      // this.document = t.files.length;

      var input;
      const formData = new FormData();
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.supupload.files[i];

          formData.append("document", input);
          // let docs = formData;

          // this.uploadload = true;
          // this.buttondisabled = true;

          this.$http
            .post(":10001/api/v1/upload/company_support_document", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                let docc = {
                  filename: response.filename,
                  fileid: response.document_id,
                  fileurl: response.url,
                };
                this.support_doc_list.push(docc);
                this.supportload = false;
                // console.log("data masuk", response);
                this.docid.push(response.document_id);
                // this.documentID.push(response.document_id);
              } else {
                console.log("data tak masuk");
              }
            })
            .catch((res) => {
              this.message = res.response.data.message;
              this.modals.failedModal = true;
            });
          // this.uploadload = false;
          // this.buttondisabled = false;
        }
      }
    },
    onFileChangee(event, index) {
      this.ships[index].uploadload = true;
      console.log(this.ships);
      const tt = event.target;
      console.log(tt.files.length);
      // if (tt.files.length > 0) {
      //   // for (let i = 0; i < tt.files.length; i++) {
      //   //   // console.log(tt.files[i])
      //   //   // let obj = {
      //   //   //   filename: tt.files[i].name,

      //   //   // }
      //   //   // this.selectedFileNamee = tt.files[i].name;
      //   //   this.ships[index].doc.filename = tt.files[i].name
      //   // }
      //   // sessionStorage.setItem("vessel-support-doc-1", this.allfilenamee);
      // } else {
      //   // this.selectedFileNamee = "";
      // }

      this.documentt = tt.files.length;

      var inputt;

      if (tt.files.length > 0) {
        for (let i = 0; i < tt.files.length; i++) {
          inputt = tt.files[i];
          const formData = new FormData();
          formData.append("document", inputt);
          this.docss = formData;

          // this.uploadload = true;
          // this.buttondisabled = true;

          this.$http
            .post(":10001/api/v1/upload/ship_support_document", this.docss, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                // this.message = response
                // this.modals.successModal = true

                console.log("data masukk", response);

                let obj = {
                  filename: response.filename,
                  fileid: response.document_id,
                  fileurl: response.url,
                };
                this.ships[index].doc.push(obj);
                // this.ships[index].doc. =

                console.log(this.ships);
                // this.shipdocid.push(response.document_id);
                // this.document_ID2.push(response.document_id);
                // this.ships[index].doc = response.document_id;
                this.ships[index].uploadload = false;
              } else {
                console.log("data tak masuk");
              }
            })
            .catch((err) => {
              this.message = err.response.message.data;
              this.modals.failedModal = true;
              this.ships[index].uploadload = false;
            });
          // this.uploadload = false;
          // this.buttondisabled = false;
        }
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.documentID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
    removeFile2(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.support_doc_list.length) {
        this.documentID.splice(indexToRemove, 1);
        this.support_doc_list.splice(indexToRemove, 1);
      }
      sessionStorage.setItem("vessel-support-doc", this.support_doc_list);
      // this.$emit("change", null);
    },
    removeFilee(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.document_ID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
    removeFilee2(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.support_doc_list.length) {
        this.documentID.splice(indexToRemove, 1);
        this.support_doc_list.splice(indexToRemove, 1);
      }
      sessionStorage.setItem("vessel-support-doc-1", this.support_doc_list);
      // this.$emit("change", null);
    },
    getOperationType() {
      (this.selects.operationtypes = []),
        this.$http.get(":10001/api/v1/setting/ship_operation").then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].operation_type_name,
                value: response[i].operation_type_id,
              };

              this.selects.operationtypes.push(obj);
            }
            //default value
            if (typeof this.operationtypevalue === "number") {
              this.selects.operationtype =
                this.selects.operationtypes[this.operationtypevalue].value;
            } else {
              this.selects.operationtype = this.selects.operationtypes[0].value;
            }
          }
        });
    },

    //need to pass all data from this page to next page
    getDone() {
      console.log("huhuhuh");
      let flag = "notchecked";
      for (var i = 0; i < this.pics.length; i++) {
        if (
          this.pics[i].fullname != "" &&
          this.pics[i].password != "" &&
          this.pics[i].confirmpassword != "" &&
          this.pics[i].phoneno1 != "" &&
          this.pics[i].email != "" &&
          this.companyname != "" &&
          this.selects.operationtype != "" &&
          this.companyaddress != "" &&
          this.phoneno != ""
        ) {
          flag = "checked";
        } else {
          flag = "notcheck";
        }
      }

      if (flag == "checked") {
        this.firstpage = false;
      } else {
        this.message = "Please fill all the required column";
        this.modals.infoModal = true;
      }

      // sessionStorage.setItem("vessel-company-name", this.companyname);

      // sessionStorage.setItem(
      //   "vessel-operation-type",
      //   this.selects.operationtype
      // );

      // sessionStorage.setItem("vessel-operation-type-value", this.getIndex());

      // sessionStorage.setItem("vessel-company-address", this.companyaddress);
      // sessionStorage.setItem("vessel-phone-no", this.phoneno);
      // sessionStorage.setItem("vessel-fax-no", this.faxno);
      // sessionStorage.setItem("vessel-full-name", this.fullname);
      // sessionStorage.setItem("vessel-password", this.password);
      // sessionStorage.setItem("vessel-confirm-password", this.confirmpassword);
      // sessionStorage.setItem("vessel-phone-no1", this.phoneno1);
      // sessionStorage.setItem("vessel-fax-no1", this.faxno1);
      // sessionStorage.setItem("vessel-email", this.email);
      // sessionStorage.setItem("vessel-full-name2", this.fullname2);
      // sessionStorage.setItem("vessel-password2", this.password2);
      // sessionStorage.setItem("vessel-confirm-password2", this.confirmpassword2);
      // sessionStorage.setItem("vessel-phone-no2", this.phoneno2);
      // sessionStorage.setItem("vessel-fax-no2", this.faxno2);
      // sessionStorage.setItem("vessel-email2", this.email2);
      // sessionStorage.setItem("vessel-add-pic", this.addPIC);
      // this.$router.push("/vessel-register-1");
    },
  },
  watch: {
    pics: {
      deep: true,
      handler: debounce(async function (v) {
        console.log(v);

        for (var i = 0; i < v.length; i++) {
          if (v[i].email != "") {
            console.log(this.checkemail(v[i].email));
            v[i].email_unique = await this.checkemail(v[i].email);
            console.log(this.pics[i].email_unique);
          }
        }
      }, 1000),
    },
    phoneno() {
      if (this.phoneno.length <= 7) {
        this.isphoneno = true;
      } else {
        this.isphoneno = false;
      }
    },
    companyname: debounce(function () {
      this.company_unique = "";

      let obj = {
        company_name: this.companyname,
      };

      this.$http
        .post(":10001/api/v1/helper/check-company-name", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.company_unique = response;
            this.buttondisabled = false;
          } else if (res.error) {
            this.company_unique = response.error_message;
            this.buttondisabled = true;
          } else {
            this.company_unique = "";
            this.buttondisabled = false;
          }
        })
        .catch((err) => {
          this.company_unique = err.response.data.message;
        });
      this.company_unique = "";
    }, 500),
    email: debounce(function () {
      this.email_unique = "";

      let obj = {
        user_email: this.email,
      };

      this.$http
        .post(":10001/api/v1/helper/check-user-email", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.email_unique = response;
            this.buttondisabled = false;
          } else if (res.error) {
            this.email_unique = response.error_message;
            this.buttondisabled = true;
          } else {
            this.email_unique = "";
            this.buttondisabled = false;
          }
        })
        .catch((err) => {
          this.email_unique = err.response.data.message;
        });

      this.email_unique = "";
    }, 500),
    email2: debounce(function () {
      this.email2_unique = "";

      let obj = {
        user_email: this.email2,
      };

      this.$http
        .post(":10001/api/v1/helper/check-user-email", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.email2_unique = response;
          } else if (res.error) {
            this.email2_unique = response.error_message;
            this.buttondisabled = true;
          } else {
            this.email2_unique = "";
          }
        })
        .catch((err) => {
          this.email2_unique = err.response.data.message;
        });

      this.email2_unique = "";
    }, 500),

    // pics: {
    //   handler(newpics) {
    //     newpics.forEach((item, index) => {
    //       if (this.pics[index].showPasswordMismatch && this.pics[index].confirmpassword !== this.pics[index].password)
    //       // this.checkPassword(item.password, index);
    //       this.pics[index].pwdmessage = "Password mismatch.";
    //     });
    //   },
    //   deep: true,
    // },

    // confirmpassword() {
    //   if (
    //     this.password != this.confirmpassword &&
    //     this.confirmpassword.length < 8
    //   ) {
    //     this.pwdmessage = "Password mismatch.";
    //     this.buttondisabled = true;
    //   }

    //   if (
    //     this.password == this.confirmpassword &&
    //     this.confirmpassword.length >= 8
    //   ) {
    //     this.pwdmessage = "";
    //     this.buttondisabled = false;
    //   }
    // },

    // password() {
    //   if (this.password != this.confirmpassword && this.password.length < 8) {
    //     this.buttondisabled = true;
    //   }

    //   if (this.password == this.confirmpassword && this.password.length >= 8) {
    //     this.buttondisabled = false;
    //   }
    // },

    // confirmpassword2() {
    //   if (
    //     this.password2 != this.confirmpassword2 &&
    //     this.confirmpassword2.length < 8
    //   ) {
    //     this.pwdmessage = "Password mismatch.";
    //     this.buttondisabled = true;
    //   }

    //   if (
    //     this.password2 == this.confirmpassword2 &&
    //     this.confirmpassword2.length >= 8
    //   ) {
    //     this.pwdmessage = "";
    //     this.buttondisabled = false;
    //   }
    // },

    // password2() {
    //   if (
    //     this.password2 != this.confirmpassword2 &&
    //     this.password2.length < 8
    //   ) {
    //     this.buttondisabled = true;
    //   }

    //   if (
    //     this.password2 == this.confirmpassword2 &&
    //     this.password2.length >= 8
    //   ) {
    //     this.buttondisabled = false;
    //   }
    // },

    // 'item.password': function (newValue) {
    //   this.checkPassword(newValue);
    // },

    // password2(newValue) {
    //   this.checkPassword2(newValue);
    // },

    pics: {
      handler(newpics) {
        newpics.forEach((item, index) => {
          this.checkPassword(item.password, index);
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.positionID = sessionStorage.getItem("position-id");
    this.roleID = sessionStorage.getItem("role-id");
    this.addPIC = sessionStorage.getItem("vessel-add-pic");
    // this.documentID = sessionStorage.getItem("vessel-support-doc");
    // this.document_ID2 = sessionStorage.getItem("vessel-support-doc");
    console.log(this.document_ID2);
    // this.documentID.split(",").map(Number);

    // this.companyname = sessionStorage.getItem("vessel-company-name");
    // this.operationtype = sessionStorage.getItem("vessel-operation-type");
    // this.companyaddress = sessionStorage.getItem("vessel-company-address");
    // this.phoneno = sessionStorage.getItem("vessel-phone-no");
    // this.faxno = sessionStorage.getItem("vessel-fax-no");

    // this.fullname = sessionStorage.getItem("vessel-full-name");
    // this.email = sessionStorage.getItem("vessel-email");
    // this.phoneno1 = sessionStorage.getItem("vessel-phone-no1");
    // this.faxno1 = sessionStorage.getItem("vessel-fax-no1");
    // this.password = sessionStorage.getItem("vessel-password");
    // this.confirmpassword = sessionStorage.getItem("vessel-confirm-password");

    // this.fullname2 = sessionStorage.getItem("vessel-full-name2");
    // this.email2 = sessionStorage.getItem("vessel-email2");
    // this.phoneno2 = sessionStorage.getItem("vessel-phone-no2");
    // this.faxno2 = sessionStorage.getItem("vessel-fax-no2");
    // this.password2 = sessionStorage.getItem("vessel-password2");
    // this.confirmpassword2 = sessionStorage.getItem("vessel-confirm-password2");

    // this.shipname =
    //   sessionStorage.getItem("vessel-ship-name") !== null &&
    //   sessionStorage.getItem("vessel-ship-name") !== "null"
    //     ? sessionStorage.getItem("vessel-ship-name")
    //     : "";

    // this.imono =
    //   sessionStorage.getItem("vessel-imo-no") !== null &&
    //   sessionStorage.getItem("vessel-imo-no") !== "null"
    //     ? sessionStorage.getItem("vessel-imo-no")
    //     : "";

    // this.grosstonnage =
    //   sessionStorage.getItem("vessel-gross-tonnage") !== null &&
    //   sessionStorage.getItem("vessel-gross-tonnage") !== "null"
    //     ? sessionStorage.getItem("vessel-gross-tonnage")
    //     : "";

    // this.deadweight =
    //   sessionStorage.getItem("vessel-dead-weight") !== null &&
    //   sessionStorage.getItem("vessel-dead-weight") !== "null"
    //     ? sessionStorage.getItem("vessel-dead-weight")
    //     : "";

    // this.ownername =
    //   sessionStorage.getItem("vessel-owner-name") !== null &&
    //   sessionStorage.getItem("vessel-owner-name") !== "null"
    //     ? sessionStorage.getItem("vessel-owner-name")
    //     : "";

    // this.callsign =
    //   sessionStorage.getItem("vessel-call-sign") !== null &&
    //   sessionStorage.getItem("vessel-call-sign") !== "null"
    //     ? sessionStorage.getItem("vessel-call-sign")
    //     : "";

    // this.shiptypevalue =
    //   sessionStorage.getItem("vessel-ship-type-value") !== null &&
    //   sessionStorage.getItem("vessel-ship-type-value") !== "null"
    //     ? sessionStorage.getItem("vessel-ship-type-value")
    //     : "";

    // this.shiptypevalue = parseInt(this.shiptypevalue);

    // this.specify =
    //   sessionStorage.getItem("vessel-ship-type-specify") !== null &&
    //   sessionStorage.getItem("vessel-ship-type-specify") !== "null"
    //     ? sessionStorage.getItem("vessel-ship-type-specify")
    //     : "";

    // this.flag =
    //   sessionStorage.getItem("vessel-flag") !== null &&
    //   sessionStorage.getItem("vessel-flag") !== "null"
    //     ? sessionStorage.getItem("vessel-flag")
    //     : "";

    // this.flag = parseInt(this.flag);

    // this.support_doc =
    //   sessionStorage.getItem("vessel-support-doc-1") !== null &&
    //   sessionStorage.getItem("vessel-support-doc-1") !== "null"
    //     ? sessionStorage.getItem("vessel-support-doc-1")
    //     : "";

    // this.support_doc = sessionStorage.getItem("vessel-support-doc-1");
    // this.allfilename = this.support_doc.split(",").map(String);
    // this.support_doc_list = this.allfilename;

    // this.support_doc = sessionStorage.getItem("vessel-support-doc-1");

    // if (this.support_doc) {
    //   this.support_doc_list = this.support_doc.trim().split(",").map(String);
    // } else {
    //   this.support_doc_list = [];
    // }
    // this.companyname =
    //   sessionStorage.getItem("vessel-company-name") !== null &&
    //   sessionStorage.getItem("vessel-company-name") !== "null"
    //     ? sessionStorage.getItem("vessel-company-name")
    //     : "";

    // this.operationtypevalue =
    //   sessionStorage.getItem("vessel-operation-type-value") !== null &&
    //   sessionStorage.getItem("vessel-operation-type-value") !== "null"
    //     ? sessionStorage.getItem("vessel-operation-type-value")
    //     : "";

    // this.operationtypevalue = parseInt(this.operationtypevalue);

    // this.selects.operationtype =
    //   sessionStorage.getItem("vessel-operation-type") !== null &&
    //   sessionStorage.getItem("vessel-operation-type") !== "null"
    //     ? sessionStorage.getItem("vessel-operation-type")
    //     : "";

    // this.companyaddress =
    //   sessionStorage.getItem("vessel-company-address") !== null &&
    //   sessionStorage.getItem("vessel-company-address") !== "null"
    //     ? sessionStorage.getItem("vessel-company-address")
    //     : "";

    // this.phoneno =
    //   sessionStorage.getItem("vessel-phone-no") !== null &&
    //   sessionStorage.getItem("vessel-phone-no") !== "null"
    //     ? sessionStorage.getItem("vessel-phone-no")
    //     : "";

    // this.faxno =
    //   sessionStorage.getItem("vessel-fax-no") !== null &&
    //   sessionStorage.getItem("vessel-fax-no") !== "null"
    //     ? sessionStorage.getItem("vessel-fax-no")
    //     : "";

    // this.fullname =
    //   sessionStorage.getItem("vessel-full-name") !== null &&
    //   sessionStorage.getItem("vessel-full-name") !== "null"
    //     ? sessionStorage.getItem("vessel-full-name")
    //     : "";

    // this.support_doc =
    //   sessionStorage.getItem("vessel-support-doc") !== null &&
    //   sessionStorage.getItem("vessel-support-doc") !== "null"
    //     ? sessionStorage.getItem("vessel-support-doc")
    //     : "";

    //     if (!this.support_doc) {
    //     this.support_doc_list = [];
    // } else {
    //     this.support_doc_list = this.support_doc.split(",").map(String);
    // }

    // this.support_doc_list = this.support_doc.split(",").map(String);
    //      this.support_doc = sessionStorage.getItem("vessel-support-doc");
    //     this.support_doc_list = this.support_doc.trim().split(",").map(String);
    // console.log("hoii", this.support_doc_list);
    // this.support_doc_list = this.allfilename;

    // this.support_doc = sessionStorage.getItem("vessel-support-doc");

    // if (this.support_doc) {
    //   this.support_doc_list = this.support_doc.trim().split(",").map(String);
    // } else {
    //   this.support_doc_list = [];
    // }

    // this.password =
    //   sessionStorage.getItem("vessel-password") !== null &&
    //   sessionStorage.getItem("vessel-password") !== "null"
    //     ? sessionStorage.getItem("vessel-password")
    //     : "";

    // this.confirmpassword =
    //   sessionStorage.getItem("vessel-confirm-password") !== null &&
    //   sessionStorage.getItem("vessel-confirm-password") !== "null"
    //     ? sessionStorage.getItem("vessel-confirm-password")
    //     : "";

    // this.phoneno1 =
    //   sessionStorage.getItem("vessel-phone-no1") !== null &&
    //   sessionStorage.getItem("vessel-phone-no1") !== "null"
    //     ? sessionStorage.getItem("vessel-phone-no1")
    //     : "";

    // this.faxno1 =
    //   sessionStorage.getItem("vessel-fax-no1") !== null &&
    //   sessionStorage.getItem("vessel-fax-no1") !== "null"
    //     ? sessionStorage.getItem("vessel-fax-no1")
    //     : "";

    // this.email =
    //   sessionStorage.getItem("vessel-email") !== null &&
    //   sessionStorage.getItem("vessel-email") !== "null"
    //     ? sessionStorage.getItem("vessel-email")
    //     : "";

    // this.fullname2 =
    //   sessionStorage.getItem("vessel-full-name2") !== null &&
    //   sessionStorage.getItem("vessel-full-name2") !== "null"
    //     ? sessionStorage.getItem("vessel-full-name2")
    //     : "";

    // this.password2 =
    //   sessionStorage.getItem("vessel-password2") !== null &&
    //   sessionStorage.getItem("vessel-password2") !== "null"
    //     ? sessionStorage.getItem("vessel-password2")
    //     : "";

    // this.confirmpassword2 =
    //   sessionStorage.getItem("vessel-confirm-password2") !== null &&
    //   sessionStorage.getItem("vessel-confirm-password2") !== "null"
    //     ? sessionStorage.getItem("vessel-confirm-password2")
    //     : "";

    // this.phoneno2 =
    //   sessionStorage.getItem("vessel-phone-no2") !== null &&
    //   sessionStorage.getItem("vessel-phone-no2") !== "null"
    //     ? sessionStorage.getItem("vessel-phone-no2")
    //     : "";
    // this.faxno2 =
    //   sessionStorage.getItem("vessel-fax-no2") !== null &&
    //   sessionStorage.getItem("vessel-fax-no2") !== "null"
    //     ? sessionStorage.getItem("vessel-fax-no2")
    //     : "";
    // this.email2 =
    //   sessionStorage.getItem("vessel-email2") !== null &&
    //   sessionStorage.getItem("vessel-email2") !== "null"
    //     ? sessionStorage.getItem("vessel-email2")
    //     : "";

    // this.addPIC =
    //   sessionStorage.getItem("vessel-add-pic") !== null &&
    //   sessionStorage.getItem("vessel-add-pic") !== "null"
    //     ? sessionStorage.getItem("vessel-add-pic")
    //     : "false";
  },
  created() {
    this.getOperationType();
    this.getShipType();
    this.getFlagState();
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}

.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.scrollable {
  height: 60px;
  overflow-y: scroll;
  color: #A5A5A5;
}

.custom-dropdown .el-select-dropdown {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-option {
  color: #333;
  background-color: #fff;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

.red-circle {
  color: #EC1B23;
  font-size: 12px;
}

.green-circle {
  color: #0BAA00;
  font-size: 12px;
}
</style>
